export default __webpack_public_path__ + "static/media/publicIWMILogo.4eb01155.svg";